import _mapValues from 'lodash/mapValues';
import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducer.root';
import { routerMiddleware } from 'react-router-redux';
import rootSagas, { getSagas } from './sagas.root';

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const middlewares = [
    sagaMiddleware,
    routerMiddleware(history)
];

const logger = createLogger({
    collapsed: true,
    diff: true,
    stateTransformer: state =>
        _mapValues(state, reducer => {
            if (reducer.toJS) {
                return reducer.toJS();
            }
            return reducer;
        })
});

if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
}

export const store = configureStore({
    devTools: process.env.NODE_ENV !== 'production',
    middleware: getDefaultMiddleware => [...getDefaultMiddleware({
        serializableCheck: false
    }), ...middlewares],
    reducer: rootReducer()
});

store.runSaga = sagaMiddleware.run;
store.runSaga(rootSagas);

if (module.hot) {
    let sagaTask = sagaMiddleware.run(function* () {
        yield getSagas();
    });
    module.hot.accept('./sagas.root.js', () => {
        sagaTask.cancel();
        sagaTask.toPromise().then(() => {
            sagaTask = sagaMiddleware.run(function* replacedSaga (action) {
                yield all(getSagas());
            });
        });
    });
    module.hot.accept('./reducer.root.js', () => {
        const newRootReducer = combineReducers(rootReducer());
        store.replaceReducer(newRootReducer);
    });
}
